import(/* webpackMode: "eager" */ "/Users/lorion/Documents/code/clipglobe/web/app/[locale]/error.tsx");
